<template>
  
  <div class="drop_menu" :style="styleChessvisObject">
  <span class="brand-header" >Verbal Chess</span>
  <span >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ title }}</span>
  <span v-show="microphoneFlag == false" class="microphone-note">
              <em>*** Note: Mic. is Muted ***</em></span>
  </div>
</template>

<script setup>

import { ref, watch } from 'vue'
import { computed } from "@vue/reactivity"

const props = defineProps({
    title : {
      type : String,
      default : "title"
    },
    microphoneFlag : {
      type : Boolean,
      default : true
    }
  })

  const title = computed({
    get() {
      return props.title
    }
  })

  const microphoneFlag = computed({
    get() {
      return props.microphoneFlag
    }
  })

const styleChessvisObject = ref({
    "font-size" : "24px",
    "font-family": "Nunito, sans-serif",
    //"font-family" : "Abel, sans-serif" 
  })


</script>

<style scoped>

.brand-header {
  font-size: 28px;
  line-height : 20px;
}

.drop_menu {
  background: #943924;
  color : #fffbf0;
	padding:5px;
	margin:0;
	height:40px;
	z-index:100;

  /*font-family: "Nunito", sans-serif;   /* rounded */
  /* font-family: "Wire One", sans-serif;  /* too narrow */
  font-family: "Abel", sans-serif;  /*good narrow */

}

.microphone-note {
  font-size: 14px;
  text-align: right;
  margin-left : 20px;
}

</style>